// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__qoSVh","checkboxChecked":"styles_checkboxChecked__CkXe3"};